<script>
  import { onMount, onDestroy, afterUpdate } from "svelte"
  import notify from "../../../../../Script/notify"
  import templateStore, { jsonToTemplate, templateToJSON } from "../../../../../Stores/metadataStore"
  import { removeEmptyKeys } from "../../../../../Script/removeEmptyKey"
  import ApplicationState from "../../../../../Stores/applicationStates"
  import { isValidJSONObject } from "../script/checkValidJson"
  import { checkJsonKeysLength } from "../script/checkJsonKeyLength"
  import { checkKeysValidity } from "../script/checkJsonKeysValidity"
  import { checkObjectSections } from "../script/checkObjectSection"
  import { checkDuplicateKeys } from "../script/checkJsonDuplicateKeys"
  import { formatJSONString } from "../script/makeJsonUnique"

  /**
   * JSON object containing data.
   * @type {Object}
   */
  let json = {}

  /**
   * The textarea element.
   * @type {HTMLTextAreaElement}
   */
  let textarea

  /**
   * The json content in textarea.
   * @type {String}
   */
  let jsoncontent

  /**
   * @type{Number} - To track click count to enable editing mode in json editor
   */
  let clickCount = 0
  /**
   * @type{Object} - parsed jsoncontent
   */
  let testJson
  /**
   * @type{Boolean} - To enable editing mode in json editor
   */
  let disableReadOnly = false

  /**
   * @type{Boolean} - To hide editing mode notification after single time.
   */
  let hideNotify = false

  /**
   * @type {Number} - json key max length
   */
  let maxKeyLength = 30

  /**
   * @type {Number} - json key max length
   */
  let maxValueLength = 120

  /**
   * @type {enableEditingNotification} - json editor enable mode activated or not
   */
  let enableEditingNotification = {
    /**
     * Closes the notification.
     */
    close() {},
  }
  /**
   * @type {disableEditingNotification} - json editor disble mode activated or not
   */
  let disableEditingNotification = {
    /**
     * Closes the notification.
     */
    close() {},
  }
  // /**
  //  * @type {Boolean} - to check json content have duplicate keys.
  //  */
  // let hasDuplicateKeys = false
  // /**
  //  * @description - Function to automatically adjust the height of a textarea element based on its content.
  //  */
  // const autoGrow = () => {
  //   textarea.style.height = textarea.scrollHeight + "px"
  // }

  /**
   * @description - Function to automatically adjust the height of a textarea element based on its content.
   */
  const autoGrow = () => {
    if (textarea) {
      textarea.style.height = "auto" // Reset the height to auto
      textarea.style.height = textarea.scrollHeight + "px" // Set the height to match the content
    }
  }

  // /**
  //  * Recursively removes duplicate keys from an object within the same object, considering keys to be case-insensitive.
  //  *
  //  * @param {Object} obj - The object to process.
  //  * @returns {Object} - A new object with duplicate keys removed within the same object, preserving the original case.
  //  */
  // const removeDuplicateKeys = (obj) => {
  //   // Check if the input is not an object or is null, return it as is
  //   if (typeof obj !== "object" || obj === null) {
  //     return obj
  //   }

  //   // If the input is an array, recursively process each item in the array
  //   if (Array.isArray(obj)) {
  //     return obj.map((item) => removeDuplicateKeys(item))
  //   }

  //   // Create an empty object to store the result without duplicate keys
  //   const result = {}
  //   // Create a Set to keep track of seen keys
  //   const seenKeys = new Set()

  //   // Iterate through the keys of the input object
  //   for (const key in obj) {
  //     // Check if the key is a direct property of the object
  //     if (Object.prototype.hasOwnProperty.call(obj, key)) {
  //       // Normalize the key by converting it to lowercase
  //       const normalizedKey = key.toLowerCase()

  //       // Check if the normalized key has not been seen before
  //       if (!seenKeys.has(normalizedKey)) {
  //         // Add the normalized key to the set of seen keys
  //         seenKeys.add(normalizedKey)
  //         // Recursively process the value associated with the key and add it to the result
  //         result[key] = removeDuplicateKeys(obj[key])
  //       } else {
  //         // Set a variable indicating duplicate keys are found
  //         hasDuplicateKeys = true
  //       }
  //     }
  //   }
  //   // Return the object with duplicate keys removed
  //   return result
  // }

  /**
   * Enables JSON modification and displays a success notification when a condition is met.
   */
  const enableJsonModify = () => {
    // Increment the "clickCount" variable
    clickCount++

    // Check if the "clickCount" has reached 7 or more and the "hideNotify" flag is not set
    if (clickCount >= 7 && !hideNotify) {
      // Close the "enableEditingNotification" (presumably a notification) when the function is called
      enableEditingNotification.close()
      // Set the "disableReadOnly" flag to true
      disableReadOnly = true

      // Display a success notification, presumably indicating that JSON Editor's editing mode has been enabled
      enableEditingNotification = notify.success("JSON Editor's editing mode has been enabled.")

      // Set the "hideNotify" flag to true, preventing further notifications
      hideNotify = true
    }
  }

  /**
   * Disables JSON editing mode and resets related variables.
   * This function resets the click count, disables read-only mode, and resets the notification flag.
   */
  const disableJSONModify = async () => {
    try {
      disableEditingNotification.close()
      if (isValidJSONObject($ApplicationState.jsonEditorContent) == false) {
        throw "The JSON appears to be invalid. Please correct it to make as a valid JSON."
      }
      testJson = JSON.parse(jsoncontent)

      try {
        if (testJson.receiver == undefined || testJson.issuer == undefined || testJson.document == undefined) {
          throw null
        }
      } catch (error) {
        throw "Ensure that the <strong>receiver, document, issuer </strong> are not modified."
      }
      try {
        //targeting mandatory keys
        if (testJson.receiver.name == undefined || testJson.issuer.signatory == undefined || testJson.document.type == undefined) {
          throw null
        }
      } catch (error) {
        throw "Ensure mandatory Keys <strong>name, type, signatory </strong> are not modified."
      }
      let checkJson = jsoncontent
      formatJSONString(checkJson)
      checkDuplicateKeys($ApplicationState.jsonEditorContent)

      // testJson = removeDuplicateKeys(testJson)
      if (testJson.receiver.name) {
        throw "Receiver name should be empty, kindly remove the given value."
      }

      // if (hasDuplicateKeys) {
      //   // Do something with the information that duplicate keys were found
      //   throw "Duplicate keys were found in the json, Kindly remove or modify them."
      // }

      await checkJsonKeysLength(testJson, maxKeyLength, maxValueLength)

      await checkKeysValidity(testJson)
      if ((await checkObjectSections(testJson)) == false) {
        throw "JSON should contain <Strong> receiver, document, issuer </strong> properties only."
      }

      // Reset the click count to 0
      clickCount = 0

      // Enable read-only mode
      disableReadOnly = false

      // Reset the notification flag to allow future notifications
      hideNotify = false
      disableEditingNotification = notify.success("JSON Editor's editing mode has been disabled.")
    } catch (error) {
      // If an error occurs, log it to the console
      console.error(error)
      disableEditingNotification = notify.warning(error.toString())
    }
    // finally {
    //   hasDuplicateKeys = false
    // }
  }

  /**
   * onMount event handler that is called when the component is mounted.
   */
  onMount(() => {
    // Delay the autoGrow function call by 10 milliseconds to ensure the textarea is rendered.
    setTimeout(autoGrow, 10)

    // Convert the template data from the $templateStore to JSON and assign it to the `json` variable.
    json = templateToJSON($templateStore)

    // Remove any empty keys from the `json` object.
    removeEmptyKeys(json)

    // Convert the `json` object to a formatted JSON string and assign it to the `jsoncontent` variable.
    jsoncontent = JSON.stringify(json, null, 4)
  })

  afterUpdate(() => {
    try {
      if (jsoncontent) {
        $ApplicationState.jsonEditorContent = jsoncontent
        $ApplicationState.updateTempStoreJSON = true
      }
    } catch (error) {
      // console.error(error)
      $ApplicationState.updateTempStoreJSON = false
    }
  })
  onDestroy(async () => {
    const info = "PAGE: Edit Document template (JSON Editor)\nEVENT: onDestroy"
    try {
      //checking for empty json(if yes, throws error and return)
      if (!jsoncontent) {
        throw new Error("Json cannot be empty")
      }

      // Remove all occurrences of four consecutive spaces with an empty string in the `jsoncontent` variable.
      jsoncontent = jsoncontent.replaceAll("    ", "")

      // Remove all occurrences of newline characters (`\n`) with an empty string in the `jsoncontent` variable.
      jsoncontent = jsoncontent.replaceAll("\n", "")

      // Replace the substring `"},}" with "}}" in the `jsoncontent` variable.
      jsoncontent = jsoncontent.replaceAll("},}", "}}")

      // Replace the substring `",}` with "`}"` in the `jsoncontent` variable.
      jsoncontent = jsoncontent.replaceAll('",}', '"}')
      let parsedJson
      //checking for valid json data
      try {
        parsedJson = JSON.parse(jsoncontent)
      } catch (error) {
        // console.error(error)
        throw "The JSON appears to be invalid, replacing with previous values."
      }
      // if (parsedJson) {
      try {
        //targeting mandatory keys
        if (parsedJson.receiver == undefined || parsedJson.issuer == undefined || parsedJson.document == undefined) {
          throw null
        }
      } catch (error) {
        throw "Ensure that the <strong>receiver, document, issuer </strong> are not modified, replacing with previous values."
      }
      if (parsedJson.receiver.name) {
        // Keep receiver.name unchanged from the original JSON data
        parsedJson.receiver.name = json.receiver.name
        notify.danger("Receiver name should be empty, replacing with previous values.", info)
        return
      }
      try {
        checkDuplicateKeys($ApplicationState.jsonEditorContent)
      } catch (error) {
        notify.danger("Duplicate keys were found in the json, replacing with previous values.", info)
        return
      }
      // try {
      //   testJson = removeDuplicateKeys(testJson)
      //   if (hasDuplicateKeys) {
      //     // Do something with the information that duplicate keys were found
      //     notify.danger("Duplicate keys were found in the json, replacing with previous values.", info)
      //   }
      // } catch (error) {
      //   throw error
      // }

      //checking for mandotory keys should be present
      try {
        //targetting mandatory keys
        if (parsedJson.receiver.name == undefined || parsedJson.issuer.signatory == undefined || parsedJson.document.type == undefined) {
          // return notify.warning("Ensure mandatory Keys are not modified, reverting to previously valid version")

          throw null
        }
      } catch (error) {
        // console.error(error)
        throw "Ensure mandatory Keys <strong>name, type, signatory </strong> are not modified, replacing with previous values."
      }

      await checkJsonKeysLength(parsedJson, maxKeyLength, maxValueLength)
      await checkKeysValidity(parsedJson)

      if ((await checkObjectSections(parsedJson)) == false) {
        throw "JSON should contain <Strong> receiver, document, issuer </strong> properties only, replacing with previous values."
      }

      // Convert the `parsedJson` object to template data using the `jsonToTemplate` function and assign it to the `newTemplateData` variable.
      let newTemplateData = jsonToTemplate(parsedJson)

      // Update the `templateStore` by invoking the `update` function and returning the `newTemplateData`.
      templateStore.update(() => {
        return newTemplateData
      })
      // }
    } catch (error) {
      json = templateToJSON($templateStore)

      // Remove any empty keys from the `json` object.
      removeEmptyKeys(json)

      // Convert the `json` object to a formatted JSON string and assign it to the `jsoncontent` variable.
      jsoncontent = JSON.stringify(json, null, 4)
      $ApplicationState.jsonEditorContent = jsoncontent
      // console.error(error)
      notify.danger(error.toString(), info)
    } finally {
      $ApplicationState.updateTempStoreJSON = false
    }
  })
</script>

<div class="relative">
  <textarea
    on:click|stopPropagation={() => {
      enableJsonModify()
    }}
    readonly={!disableReadOnly}
    on:input={autoGrow}
    bind:value={jsoncontent}
    bind:this={textarea}
    class="block h-auto min-h-[350px] w-full resize-none overflow-hidden break-all rounded-md border border-[#a0a1a580] bg-white px-3 py-2 pl-5 text-sm text-gray-800 placeholder-gray-400 outline-none focus:border {!disableReadOnly ? 'focus:border-blue-500 focus:ring-blue-500' : 'focus:border-green-500 focus:ring-green-500'} focus:ring-1 dark:bg-lightgray dark:text-slate-200"
  />
  <button on:click|stopPropagation={disableJSONModify} class:hidden={!disableReadOnly} type="button" class="absolute top-3 right-3 flex h-9 w-24 min-w-[36px] items-center justify-center rounded-md bg-green-500 px-2 text-sm font-medium text-white hover:bg-green-600 focus:outline-none active:bg-green-500 lg:px-2">
    <!-- <i class="fa-solid fa-paper-plane-top hidden mobile:flex" /> -->
    <i class="fa-solid fa-pen-nib-slash" />
    &nbsp; Disable
  </button>
</div>
